<div class="container section__cash-in h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-300">
      <article>
        <div class="mainInfo">
          <h1>Desembolso</h1>
          <p>
            ¿Dónde deseas que depositemos
            <br>
            el dinero?
          </p>
        </div>

        <div class="backgroundArrow">
          <div class="arrowSvg">
            <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.5">
                <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
              </g>
              <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <div class="subtitle mb-15">
          <h2>Confirma la información para el desembolso:</h2>
        </div>

        <!-- TRANSFERENCIA A OTROS BANCOS -->
        <div class="radioSelectionBox">
          <div class="radioSelectionBox__item">
            <label pRipple class="radioButtonBox" [for]="optionPayment['banking-transfer']">
              <p-radioButton name="paymentOption" [(ngModel)]="selectedOption" [value]="optionPayment['banking-transfer']" [inputId]="optionPayment['banking-transfer']"></p-radioButton>
              <span class="radioButtonBox__text">
                <span class="inline-content">
                  Transferencia a otros bancos
                </span>
                <small>Tendrás tu dinero máximo en 12 horas hábiles</small>
              </span>
            </label>
          </div>
        </div>
      </article>

      <footer>
        <div class="footer__content">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="!selectedOption" (click)="onContinue()"></button>
        </div>
      </footer>
    </div>
  </div>
</div>

<!-- TRANSFERENCIA BANCARIA MODAL -->
<app-banking-transfer (gotoStepEvent)="onGotoStep($event)" (nextStepEvent)="onNextStep()" [request]="request" [visibleBankTransferModal]="visibleBankTransferModal" (onClose)="onCloseBankTransferModal($event)" />

<!-- LUKI MODAL -->
<app-luki-client (gotoStepEvent)="onGotoStep($event)" [visibleLukiModal]="visibleLukiModal" (onClose)="onCloseLukyModal($event)" (onLukiStatus)="onSetLukiStatus($event)" />

<!-- LUKI BANNER MODAL -->
<app-luki-banner [visibleLukiBannerModal]="visibleLukiBannerModal" (onClose)="onCloseLukiBannerModal($event)" />
